import React from "react";
import { useEffect, useState, useLayoutEffect } from "react";
import { Row, Col } from "react-bootstrap";

import { CommonButton } from "components/common/button/Button";
import Plus from "assets/icons/Plus";
import { TailSpin } from "react-loader-spinner";

import { useNavigate } from "react-router-dom";

import { useLocation, useParams } from "react-router-dom";
import { Briefcase } from "phosphor-react";
import { pageSize } from "common/constants/constants";
import Paginate from "components/common/pagination/Paginate";
import TableCommon from "components/common/dynamicTable/DynamicTable";
import { getTeamList, deleteTeam } from "services/branchServices";
import TeamsModalWrapper from "components/common/teamsModalWrapper/TeamsModalWrapper";
import TeamsDataDeleteModal from "components/common/teamsDataDeleteModal/TeamsDataDeleteModal";
import TeamMemberDetail from "./teamMemberDetail/TeamMemberDetail";
import { useTranslation } from "react-i18next";
const Teams = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const { pathIds } = location.state;
  const branchName = localStorage.getItem("branchName");

  const tableHeading = [t("member-name"), t("description"), t("actions")];
  const [userList, setUserList] = useState([]);

  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
  });
  const [show, setShow] = useState(false);
  const [teamMemberId, setTeamMemberId] = useState("");

  const [isFetching, setIsFetching] = useState(false);
  const [refresh, setRefresh] = useState(false);

  let filters = {
    searchString: "",
    orderBy: "",
    filter: "",
    orderType: "",
  };

  const handleClose = () => {
    setTeamMemberId("");
    setShow(false);
  };
  const deleteTeamData = async (teamMemberId) => {
    setTeamMemberId(teamMemberId);
    setShow(true);
  };

  const HandleDeleteConfirmation = async () => {
    await deleteTeam(pathIds, teamMemberId);

    handleRefresh();
    setShow(false);
  };

  const handleRefresh = () => {
    setRefresh((pre) => !pre);
  };

  const handleNextPage = (data) => {
    const { selected } = data;
    setPagination((pre) => {
      return { ...pre, currentPage: selected + 1 };
    });
  };
  useLayoutEffect(() => {
    getTeamLists();
  }, [refresh, pagination.currentPage]);

  const getTeamLists = async () => {
    const { currentPage: pageNumber } = pagination;
    setIsFetching(true);
    const result = await getTeamList(pathIds, filters, pageNumber);

    if (result?.success) {
      setUserList(result?.payLoad?.items);

      setPagination({ ...pagination, totalPages: result?.payLoad?.totalPages });
    }
    setIsFetching(false);
  };
  return (
    <>
      <div className="custom-breadcrumbs mx-5 px-2">
        <span
          className="breadcrumbs-item "
          onClick={() => {
            navigate("/branch-detail");
          }}
        >
          {t("branches")}
        </span>
        <span
          className="breadcrumbs-item"
          onClick={() => {
            navigate("/branch-detail");
          }}
        >
          {branchName}
        </span>
      </div>
      <div className="payment-info-container" style={{ marginTop: "-35px" }}>
        <p className="page-title">{t("create-teams")}</p>
        <hr style={{ height: "1px" }} />
        <br />

        <CommonButton
          float="right"
          click={() =>
            navigate("createNewMember", { state: { pathIds, filters } })
          }
          title={
            <span>
              <Plus style={{ fill: "white", marginRight: "8px" }} width={15} />
              <span>{t("create-new-member")}</span>
              <br />
            </span>
          }
          borderRadius="20px"
          fontSize="10px"
          fontWeight="500"
          color="white"
          border=" none"
          padding="10px 15px"
          justify-content="center"
        />
      </div>
      {isFetching ? (
        <TailSpin
          height="90"
          width="90"
          color="#ffff"
          radius="1"
          visible={true}
        />
      ) : userList.length === 0 ? (
        <div
          className="d-flex justify-content-center align-items-center flex-column"
          style={{ height: "40vh" }}
        >
          <Briefcase size={62} className="mt-5 opacity-50" />
          <p className="opacity-50">{t("no-record-found")}</p>
        </div>
      ) : (
        <div className="payment-info-container">
          <>
            <TableCommon
              heading={tableHeading}
              name="Teams"
              body={userList}
              tableStyle={{
                minHeight: "40vh",
                maxHeight: "40vh",
              }}
              permissionToEdit={true}
              className="tableHeader"
              deleteTeamData={deleteTeamData}
              pathIds={pathIds}
            />
            {}
            <Paginate
              totalPages={pagination.totalPages}
              handleNextPage={handleNextPage}
              currentPage={pagination.currentPage}
            />
          </>
        </div>
      )}
      <TeamsModalWrapper show={show}>
        <TeamsDataDeleteModal
          handleClose={handleClose}
          HandleDeleteConfirmation={HandleDeleteConfirmation}
        />
      </TeamsModalWrapper>
      ;
    </>
  );
};

export default Teams;
